import {
  ADD_CASE,
  ADD_LOGITEM,
  CLEAR_CASES,
  GET_CASE_BY_ID,
  GET_CASE_PRIORITIES,
  GET_CASE_STATUS,
  GET_CASE_STATUS_FOR_DOCTOR,
  GET_CASES,
  GET_CLOSED_CASES,
  GET_DOCTORS_OF_DEPT,
  GET_LOGITEM_READ_STATUS,
  GET_LOGITEMS_BY_CASE_ID,
  GET_OPEN_CASES,
  READ_LOGITEM,
  UPDATE_CASE,
  UPDATE_CASE_DOCTORS,
  GET_ALL_SYMPTOMS,
} from "./CasesActions";

const initialState = {
  casePriorities: [],
  caseStatus: [],
  case: null,
  doctors: null,
  logItems: [],
  logItem: null,
  cases: [],
  openCases: [],
  closedCases: [],
  readStatus: null,
  readLogitem: null,
  symptomsList: [],
};

/**
 * reducer function to update state based on action
 * @param state: current state of the reducer
 * @param action: action to perform on the data
 * @returns {{readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null}|({readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null} & {case: (null|*)})|({readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null} & {logItems: ([]|*)})|{readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null}|({readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null} & {logItem: (null|*)})|({readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null} & {doctors: (null|[]|*)})|{readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null}|{readStatus: (null|*), openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null}|({readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null} & {caseStatus: ([]|*)})|({readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null} & {closedCases: ([]|*)})|{readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: [], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null}|({readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null} & {casePriorities: ([]|*)})|({readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null} & {cases})|({readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: null} & {openCases: ([]|*)})|{readStatus: null, openCases: *[], cases: *[], casePriorities: *[], caseStatus: *[], logItems: *[], logItem: null, closedCases: *[], doctors: null, readLogitem: null, case: {priority, desc, status}}}
 * @constructor
 */
const CasesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CASES:
      return Object.assign({}, state, {
        cases: action.cases,
      });

    case CLEAR_CASES:
      return Object.assign({}, state, {
        cases: [],
      });

    case GET_OPEN_CASES:
      return Object.assign({}, state, {
        openCases: action.openCases,
      });

    case GET_CLOSED_CASES:
      return Object.assign({}, state, {
        closedCases: action.closedCases,
      });

    case ADD_CASE:
      return Object.assign({}, state, {
        case: action.case,
      });

    case ADD_LOGITEM:
      return Object.assign({}, state, {
        logItem: action.logItem,
      });

    case UPDATE_CASE:
      return {
        ...state,
        case: {
          ...state.case,
          desc: action.case.desc,
          status: action.case.status,
          priority: action.case.priority,
        },
      };

    case UPDATE_CASE_DOCTORS:
      return {
        ...state,
      };

    case GET_CASE_BY_ID:
      return Object.assign({}, state, {
        case: action.case,
      });

    case GET_CASE_PRIORITIES:
      return Object.assign({}, state, {
        casePriorities: action.casePriorities,
      });

    case GET_CASE_STATUS:
      return Object.assign({}, state, {
        caseStatus: action.caseStatus,
      });

    case GET_CASE_STATUS_FOR_DOCTOR:
      return Object.assign({}, state, {
        caseStatus: action.caseStatus,
      });

    case GET_DOCTORS_OF_DEPT:
      return Object.assign({}, state, {
        doctors: action.doctors,
      });

    case GET_LOGITEMS_BY_CASE_ID:
      return Object.assign({}, state, {
        logItems: action.logItems,
      });

    case GET_LOGITEM_READ_STATUS:
      return {
        ...state,
        readStatus: action.readStatus,
      };

    case GET_ALL_SYMPTOMS:
      return {
        ...state,
        symptomsList: action.symptoms,
      };

    case READ_LOGITEM:
      const tempLogItems = Object.assign({}, state.logItems);
      tempLogItems.rows.forEach((item) => {
        const readItem = action.readLogitem.find(
          (one) => one.logId === item.id
        );
        if (readItem) {
          item.readUsers = readItem.readUsers;
          item.isCurrentUserRead = true;
        }
      });

      return {
        ...state,
        logItems: tempLogItems,
      };

    default:
      return state;
  }
};

export default CasesReducer;
